import { DateTime } from 'luxon';

// Using a very strict format to ensure no misinterpretations
const isoDateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:\d{2})?$/;
const dateOnlyFormat = /^\d{4}-\d{2}-\d{2}$/;

export function jsonDateTimeReplacer(this: any, key: string, value: unknown) {
    if (value instanceof DateTime) {
        return value.setZone('utc').toISO();
    }

    if (typeof value === 'string' && isoDateFormat.test(value)) {
        const parsed = DateTime.fromISO(value);

        if (parsed.isValid) {
            return parsed.setZone('utc').toISO();
        }
    }

    return value;
}

export function jsonDateTimeReviver(key: string, value: unknown) {
    if (typeof value === 'string') {
        const isIso = isoDateFormat.test(value);
        const isDate = dateOnlyFormat.test(value);
        if (isIso || isDate) {
            try {
                if (isIso) {
                    const parsed = DateTime.fromISO(value, { setZone: true });

                    if (parsed.isValid) {
                        return parsed;
                    }
                }

                const parsed = DateTime.fromISO(value, { zone: 'default' });

                if (parsed.isValid) {
                    return parsed;
                }

                return value;
            } catch {
                // not a date
            }
        }
    }

    return value;
}
